import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/new-website.css"
import Footer from "../layout/footerUpdated";
import Header from "../layout/headerHome";
import SliderLab from "../element/component/Banner_New_Slider";
import ServiceSection from "../element/component/ServiceSectionAll";
import FAQComponent from '../element/component/faq';
import WhyLab from '../element/component/whyLab';
import TestimonialSlider from "../element/component/testimonial-slider";
import BloodTestSlider from "../element/component/TestSliderSwasth";
import { Helmet } from "react-helmet";
import Popup_Main from "../element/component/Popup_Main";
import ReachToUsForm from "../element/ReachToUsForm";
import HeroImageSlider from "../element/component/heroSliderbanner";

const LabTestPage = () => {

  const [isOpen, setIsOpen] = useState(false);

//   const Counter = ({ targetValue, duration }) => {
//     const [count, setCount] = useState(0);
//     const hasRun = useRef(false); // Ensure animation runs only once

//     useEffect(() => {
//         if (hasRun.current) return; // Prevent double execution in Strict Mode
//         hasRun.current = true; // Mark animation as started

//         let start = 0;
//         const stepTime = Math.max(duration / targetValue, 10); // Ensure minimum step time
//         const interval = setInterval(() => {
//             start += 1;
//             setCount(start);
//             if (start >= targetValue) clearInterval(interval); // Stop at target value
//         }, stepTime);

//         return () => clearInterval(interval); // Cleanup on unmount
//     }, []); // Run only once on mount

//     return <h3>{count}%</h3>;
// };
  
  const whyData = [
    { title: "Quality-Led Diagnostics", desc: "Testing supported by NABL-accredited laboratory standards.", image: "/images/new-website/physiotherapy/physiotherapist.webp" },
    { title: "Skilled Sample Collection", desc: "Careful, hygienic and patient-friendly collection by trained professionals.", image: "images/sugar-blood-test.webp" },
    { title: "Routine and Advanced Markers", desc: "A wider range of tests for everyday monitoring and preventive evaluation.", image: "/images/new-website/home-new/healthcare-home.webp" },
    { title: "Connected Healthcare", desc:"Consult Bridge Health doctors and specialists when your results need further attention.", image: "/images/new-website/audiometry/global.webp" },
  ];

// Slider settings defined here
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "15%",
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: (
        <div className="slick-prev">
            <i className="fa fa-angle-left" aria-hidden="true"></i>
        </div>
        ),
        nextArrow: (
        <div className="slick-next">
            <i className="fa fa-angle-right" aria-hidden="true"></i>
        </div>
        ),
        responsive: [
          {
            breakpoint: 1024, // Tablet view
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768, // Mobile view
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
    };

     const openPopup = () => {
    if (popupTimerRef.current) {
      clearTimeout(popupTimerRef.current);
      popupTimerRef.current = null;
    }
    setIsOpen(true);
  };

 const BloodTestsettings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: 'ease',
    swipeToSlide: true,
    draggable: true,
    touchThreshold: 10,
    variableWidth: false,
    centerMode: false,
    adaptiveHeight: false,
    useTransform: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992,  settings: { slidesToShow: 3 } },
      { breakpoint: 768,  settings: { slidesToShow: 1, centerMode: false } },
    ],
  };

    // Custom slides for this page
  const slides = [
    {
      desktop: "/images/new-website/lab-test/bh-lab4.webp",
      mobile: "/images/new-website/lab-test/bh-lab4.webp",
    },
    {
      desktop: "/images/new-website/lab-test/bh-lab3.webp",
      mobile: "/images/new-website/lab-test/bh-lab3.webp",
    },
    {
      desktop: "/images/new-website/lab-test/lab-test-3.webp",
      mobile: "/images/new-website/lab-test/lab-test-3.webp",
    },
    {
      desktop: "/images/new-website/lab-test/bh-lab2.webp",
      mobile: "/images/new-website/lab-test/bh-lab2.webp",
    },
    {
      desktop: "/images/new-website/lab-test/lab-test-5.webp",
      mobile: "/images/new-website/lab-test/lab-test-5.webp",
    },
    {
      desktop: "/images/new-website/lab-test/bh-lab.webp",
      mobile: "/images/new-website/lab-test/bh-lab.webp",
    },
  ];

  const testimonials = [
    {
      content:
        "Bridge health offers services at affordable cost. Akshata at the front desk is very cooperative and good at coordinating and follow-ups. The staff are well spoken and carried out all tests with patience.",
      name: "Akshata J Lokhande",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "I am Prof Sundararaj living at PRIMUS REFLECTION. The staff are very courteous with a smile on their faces, including all the doctors. Special thanks to Ms. Akshita!",
      name: "Sundar Raj",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Good , clean hygiene place ... Feels like your are at home with the services that provide... I have enrolled for gym here.. And the trainers are thorough professionals.. And the staff I have interacted with them during the seminars or presentations they are knowledgeable",
      name: "Shiva Kumar S",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "From sattva apartment Bridge healthy is useful for our patients.Mahendra the nursing staff is good and courteous.",
      name: "Susheela Sharan",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Laxman is an excellent nurse looking after the retired community. Gentle in taking blood. Very polite and efficient.",
      name: "Dipak Rao",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
  ];

  const faqs = [
    {
      question: "What types of lab tests does Bridge Health offer?",
      answer:
        "Bridge Health offers a wide range of lab tests, including blood tests, urine tests, imaging tests, and advanced diagnostic panels for various health conditions.",
    },
    {
      question: "Does Bridge Health offer home sample collection for lab tests?",
      answer: "Yes, Bridge Health provides convenient home sample collection services for lab tests, ensuring comfort and accessibility for patients.",
    },
    {
      question: "Where will I receive my lab test reports from Bridge Health?",
      answer: "You will receive your lab test reports digitally via email or the Bridge Health app, ensuring quick and secure access.",
    },
    {
      question: "What are Bridge Health's routine tests?",
      answer: "Routine tests include complete blood counts (CBC), blood sugar levels, lipid profiles, thyroid tests, and general health check-up panels.",
    },
    {
      question: "What's the cost of lab tests in Bangalore?",
      answer: "The cost varies based on the test, starting from ₹200 for basic tests and going up to ₹10,000 for advanced diagnostics.",
    },
  ];


  const [isMobile, setIsMobile] = useState(false);
  const sectionRefs = useRef([]); // Refs for multiple sections/cards
  const [hasAnimated, setHasAnimated] = useState([]); // Animation tracking for cards

  // Resize event listener to detect mobile view
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initialize on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll Animation Logic
  useEffect(() => {
    const handleScroll = () => {
      const updatedVisibility = sectionRefs.current.map((ref) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();
          const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

          // Element becomes visible when its top is within viewport
          return rect.top <= windowHeight - 50;
        }
        return false;
      });

      setHasAnimated((prev) =>
        updatedVisibility.map((visible, index) => prev[index] || visible)
      );
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on mount to check initial visibility
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const cardsData = [
    { title: "Routine Health Tests", image: "/images/full-body-checkup.webp" },
    { title: "Preventive Health Packages", image: "/images/health-package.webp" },
    { title: "Diabetes Management", image: "/images/sugar-blood-test.webp" },
    // { title: "Weight Management", image: "/images/weight-management.webp" },
    // { title: "Thyroid Tests", image: "/images/thyroid-test.webp" },
    // { title: "Fever Tests", image: "/images/fever.webp" },
    { title: "Heart Checkup", image: "/images/heart-checkup.webp" },
    // { title: "Kidney Checkup", image: "/images/kidney-test.webp" },
    { title: "Liver and Kidney Health Tests", image: "/images/liver-test.webp" },
    // { title: "Bone Tests", image: "/images/bone-test.webp" },
    // { title: "Blood Tests", image: "/images/blood-test.webp" },
    // { title: "Hormone Checkup", image: "/images/hormone-test.webp" },
    { title: "Nutrition and Deficiency Tests", image: "/images/vitamin-test.webp" },
    // { title: "Urine Tests", image: "/images/urine-test.webp" },
    { title: "Women's Health", image: "/images/women-care-1.webp" },
    { title: "Senior Health Checkup", image: "/images/senior-citizen.webp" },

  ];

  const styles = {
    headingwoman1: {
        fontSize: "50px",
        color:"#0d0d0d",
        fontWeight: "600",
        lineHeight: "1.2",
        textAlign: "left",
        width: "100%"
      }
      
  };


  const tests = [
    {
      icon: "/images/blood-test.webp",
      title: "Nutritional Panel",
      desc: "Decode, Nourish & Energize",
      testsIncluded: "29 parameters included",
      price: "₹340",
      originalPrice: "₹510",
      discount: "33% off",
      feature1: "Sample: Blood",
      feature2: "No Fasting Required"
    },
    {
      icon: "/images/sugar-blood-test.webp",
      title: "Fever Panel",
      desc: "Clarity on Cause of Fever",
      testsIncluded: "3 parameters included",
      price: "₹290",
      originalPrice: "₹630",
      discount: "54% off",
      feature1: "Sample: Blood, Urine",
      feature2: "No Fasting Required"
    },
    {
      icon: "/images/kidney-test.webp",
      title: "Diabetes Check Panel",
      desc: "Complete Diabetes Status",
      testsIncluded: "9 parameters included",
      price: "₹990",
      originalPrice: "₹1290",
      discount: "23% off",
      feature1: "Sample: Blood, Urine",
      feature2: "Fasting Required (8~12)"
    },
    {
      icon: "/images/kidney-test.webp",
      title: "Heart Health Panel",
      desc: "Full Heart Checkup",
      testsIncluded: "Full Heart Checkup",
      price: "₹790",
      originalPrice: "₹1090",
      discount: "28% off",
      feature1: "Sample: Blood",
      feature2: "Fasting Required (8~12)"
      
    },
    {
      icon: "/images/kidney-test.webp",
      title: "Bone Health Panel",
      testsIncluded: "14 parameters included",
      price: "₹590",
      originalPrice: "₹810",
      discount: "27% off",
      desc: "Build Bone Strength",
      feature1: "Sample: Blood",
      feature2: "No Fasting Required"
    },
    {
      icon: "/images/kidney-test.webp",
      title: "Weight Management",
      testsIncluded: "29 parameters included",
      price: "₹1090",
      originalPrice: "₹1490",
      discount: "27% off",
      desc: "Smarter Weight Loss",
      feature1: "Sample: Blood, Urine",
      feature2: "Fasting Required (8~12)"
    },
    {
      icon: "/images/kidney-test.webp",
      title: "Arthritis Panel", 
      testsIncluded: "29 parameters included",
      price: "₹3890",
      originalPrice: "₹5000",
      discount: "22% off",
      desc: "Test",
      feature1: "Sample: Blood",
      feature2: "No Fasting Required (8~12)"
    },
    
  ];

   const swasth = [
    { icon: "/images/blood-test.webp", title: "Swasth 6.1", testsIncluded: "Includes 70+ Tests", desc: "", info: "FREE Add-ons", info1: "Hearing Consultation (Only if > 60 years)", price: "₹990", originalPrice: "₹2440", discount: "37% off", feature1: "Doctor Consultation", feature2: "Fasting Required (8~12)",    
      testList: [
      "Complete Blood Count (CBC)",
      "Erythrocyte Sedimentation Rate (ESR)",
      "Fasting Blood Sugar (FBS)",
      "HbA1c",
      "Kidney Function Test With Electrolytes",
      "Liver Profile",
      "Lipid Profile",
      "Urine Routine and Microscopy"
    ],
    
    addOnsTitle: " Free Add-ons",
    addOns: [
      "Hearing Consultation (Only if > 60 years)",
    ]
  },

  { icon: "/images/blood-test.webp", title: "Swasth 6.2", testsIncluded: "Includes 80+ Tests", desc: "Doctor consultation post report", info: "FREE Add-ons", info1: "ECG, Hearing Consultation (Only if > 60 years)", price: "₹1890", originalPrice: "₹7030", discount: "36% off", feature1: "Doctor Consultation", feature2: "Fasting Required (8~12)",
      testList: [
      "Complete Blood Count (CBC)",
      "Erythrocyte Sedimentation Rate (ESR)",
      "Fasting Blood Sugar (FBS)",
      "HbA1c",
      "Kidney Function Test With Electrolytes",
      "Liver Profile",
      "Lipid Profile",
      "Urine Routine and Microscopy",
      "Thyroid Function Test",
      "Vitamin D",
      "Vitamin B12",
      "Iron Profile",
      "Total Calcium"
    ],
    addOnsTitle: "Doctor Consultation",
    consultation: "Included (1 consultation), post reports",

    addOnsTitle: "Free Add-ons",
    addOns: [
      "ECG",
      "Hearing Consultation (only if > 60 years)"
    ]

    },
    { icon: "/images/blood-test.webp", title: "Swasth 6.3", testsIncluded: "Includes 95+ Tests", desc: "Doctor consultation post report", info: "FREE Add-ons", info1: "ECG, Nutrition Consultation, Hearing Consultation (Only if > 60 years)", price: "₹2890", originalPrice: "₹10240", discount: "46% off", feature1: "Doctor Consultation", feature2: "Fasting Required (8~12)",
      testList: [
      "Complete Blood Count (CBC)",
      "Erythrocyte Sedimentation Rate (ESR)",
      "Fasting Blood Sugar (FBS)",
      "HbA1c",
      "Kidney Function Test With Electrolytes",
      "Liver Profile",
      "Lipid Profile",
      "Urine Routine and Microscopy",
      "Thyroid Function Test",
      "Vitamin D",
      "Vitamin B12",
      "Iron Profile",
      "Total Calcium",
      "Pheripheral Smear (PS)",
      "FIB-4 Index",
      "Magnesium",
      "Pancreas Profile",
      "High Sensitive CRP",
      "Lipoprotein A",
    ],
    addOnsTitle: "Doctor Consultation",
    consultation: "Included (1 consultation), post reports",

    addOnsTitle: "Free Add-ons",
    addOns: [
      "ECG",
      "Nutrition Consultation",
      "Hearing Consultation (only if > 60 years)"
    ]
    },
    { icon: "/images/blood-test.webp", title: "Complete Care (M)", testsIncluded: "Includes 100+ Tests", desc: "Doctor consultation post report", info: "FREE Add-ons", info1: "ECG, Nutrition Consultation, Hearing Consultation (Only if > 60 years)", price: "₹4890", originalPrice: "₹17580", discount: "59% off", feature1: "Doctor Consultation", feature2: "Fasting Required (8~12)",
      testList: [
      "Complete Blood Count (CBC)",
      "Erythrocyte Sedimentation Rate (ESR)",
      "Fasting Blood Sugar (FBS)",
      "HbA1c",
      "Kidney Function Test With Electrolytes",
      "Liver Profile",
      "Lipid Profile",
      "Urine Routine and Microscopy",
      "Thyroid Function Test",
      "Vitamin D",
      "Vitamin B12",
      "Iron Profile",
      "Total Calcium",
      "Pheripheral Smear (PS)",
      "FIB-4 Index",
      "Magnesium",
      "Pancreas Profile",
      "High Sensitive CRP",
      "Lipoprotein A",
      "APO-A1",
      "APO-B",
      "Urine Microalbumin",
      "Blood Grouping & RH Typing",
      "PSA",
    ],
    addOnsTitle: "Doctor Consultation",
    consultation: "Included (1 consultation), post reports",

    addOnsTitle: "Free Add-ons",
    addOns: [
      "ECG",
      "Nutrition Consultation",
      "Hearing Consultation (only if > 60 years)"
    ]
    },
    { icon: "/images/blood-test.webp", title: "Complete Care (F)", testsIncluded: "Includes 100+ Tests", desc: "Doctor consultation post report", info: "FREE Add-ons", info1: "ECG, Nutrition Consultation, Hearing Consultation (Only if > 60 years)", price: "₹4890", originalPrice: "₹18350", discount: "59% off", feature1: "Doctor Consultation", feature2: "Fasting Required (8~12)",
      testList: [
      "Complete Blood Count (CBC)",
      "Erythrocyte Sedimentation Rate (ESR)",
      "Fasting Blood Sugar (FBS)",
      "HbA1c",
      "Kidney Function Test With Electrolytes",
      "Liver Profile",
      "Lipid Profile",
      "Urine Routine and Microscopy",
      "Thyroid Function Test",
      "Vitamin D",
      "Vitamin B12",
      "Iron Profile",
      "Total Calcium",
      "Pheripheral Smear (PS)",
      "FIB-4 Index",
      "Magnesium",
      "Pancreas Profile",
      "High Sensitive CRP",
      "Lipoprotein A",
      "APO-A1",
      "APO-B",
      "Urine Microalbumin",
      "Blood Grouping & RH Typing",
      "CA-125",
    ],
    addOnsTitle: "Doctor Consultation",
    consultation: "Included (1 consultation), post reports",

    addOnsTitle: "Free Add-ons",
    addOns: [
      "ECG",
      "Nutrition Consultation",
      "Hearing Consultation (only if > 60 years)"
    ]
    },
    { icon: "/images/blood-test.webp", title: "Complete Care Plus (M)", testsIncluded: "Includes 105+ Tests", desc: "Doctor consultation post report", info: "FREE Add-ons", info1: "ECG, Nutrition Consultation, Hearing Consultation (Only if > 60 years)", price: "₹6990", originalPrice: "₹28610", discount: "67% off", feature1: "Doctor Consultation", feature2: "Fasting Required (8~12)",
      testList: [
      "Complete Blood Count (CBC)",
      "Erythrocyte Sedimentation Rate (ESR)",
      "Fasting Blood Sugar (FBS)",
      "HbA1c",
      "Kidney Function Test With Electrolytes",
      "Liver Profile",
      "Lipid Profile",
      "Urine Routine and Microscopy",
      "Thyroid Function Test",
      "Vitamin D",
      "Vitamin B12",
      "Iron Profile",
      "Total Calcium",
      "Pheripheral Smear (PS)",
      "FIB-4 Index",
      "Magnesium",
      "Pancreas Profile",
      "High Sensitive CRP",
      "Lipoprotein A",
      "APO-A1",
      "APO-B",
      "Urine Microalbumin",
      "Blood Grouping & RH Typing",
      "Fasting Insuline",
      "PSA",
      "CA-19.9",
      "S.CEA",
      "Homocysteine",
    ],
    addOnsTitle: "Doctor Consultation",
    consultation: "Included (1 consultation), post reports",

    addOnsTitle: "free Add-ons",
    addOns: [
      "ECG",
      "Nutrition Consultation",
      "Hearing Consultation (only if > 60 years)"
    ]
    },
    { icon: "/images/blood-test.webp", title: "Complete Care Plus (F)", testsIncluded: "Includes 105+ Tests", desc: "Doctor consultation post report", info: "FREE Add-ons", info1: "ECG, Nutrition Consultation, Hearing Consultation (Only if > 60 years)", price: "₹6990", originalPrice: "₹29380", discount: "67% off", feature1: "Doctor Consultation", feature2: "Fasting Required (8~12)",
    testList: [
      "Complete Blood Count (CBC)",
      "Erythrocyte Sedimentation Rate (ESR)",
      "Fasting Blood Sugar (FBS)",
      "HbA1c",
      "Kidney Function Test With Electrolytes",
      "Liver Profile",
      "Lipid Profile",
      "Urine Routine and Microscopy",
      "Thyroid Function Test",
      "Vitamin D",
      "Vitamin B12",
      "Iron Profile",
      "Total Calcium",
      "Pheripheral Smear (PS)",
      "FIB-4 Index",
      "Magnesium",
      "Pancreas Profile",
      "High Sensitive CRP",
      "Lipoprotein A",
      "APO-A1",
      "APO-B",
      "Urine Microalbumin",
      "Blood Grouping & RH Typing",
      "Fasting Insuline",
      "CA-125",
      "CA-19.9",
      "S.CEA",
      "Homocysteine",
    ],
    addOnsTitle: "Doctor Consultation",
    consultation: "Included (1 consultation), post reports",

    addOnsTitle: "Free Add-ons",
    addOns: [
      "ECG",
      "Nutrition Consultation",
      "Hearing Consultation (only if > 60 years)"
    ]
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Best NABL Accredited Blood Test Services | Top Pathology Lab in Bangalore</title>
        <meta name="description" content="Book reliable NABL & CAP-accredited lab tests in Bangalore. Wide range of diagnostics with fast results. Home sample collection available. Schedule now!" />
        <meta name="keywords" content="Book blood test in bangalore | book blood tests at home | pathology lab | liver function test |lipid profile |kidney function test | diagnostic services |" />
        <meta name="author" content="Bridge Health" />
        <meta property="og:title" content="Best NABL & ISO Accredited Blood Test Services | Top Pathology Lab in Bangalore" />
        <meta property="og:description" content="Book reliable NABL & CAP-accredited lab tests in Bangalore. Wide range of diagnostics with fast results. Home sample collection available. Schedule now!" />
        <meta property="og:image" content="https://bridgehealth.in/images/new-website/radiology/lab-test-bg.webp" />
        <meta property="og:url" content="https://bridgehealth.in/lab-tests" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header/>
      <div className={`landingcontainerLab ${isMobile ? "mobile" : ""}`}>
        <div className={`leftContainerLab ${isMobile ? "mobile" : ""}`}>
          <h1 className="first-section-heading">
          Testing that is{" "}
            <span className="highlight1">accurate, convenient, and connected</span> to what happens next.
          </h1>
          <p className="paragraph-left">Bridge Health combines NABL-accredited diagnostics, convenient sample collection and secure digital reports—so you can make informed decisions about your health.</p>
          <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Book a Lab Test</button>
        </div>
        <div className="rightContainerlab">
          <img
            src="/images/new-website/lab-test/Bh-lab-banner.webp"
            alt="Woman smiling"
            className="imagelandinglab imageFadeInUp"
          />
        </div>
      </div>

      {/* <HeroImageSlider setIsOpen={setIsOpen} /> */}
      
            <section>
            <div className="rightstrongcontainerlab">
            <h2 className="heading1">
            Tests for Every Stage of Your
              <span className="highlight1"> Health Journey</span>
              <span className="line-break-heading"></span>
            </h2>
              <ServiceSection
                cardsData={cardsData}
                isMobile={isMobile}
                highlight="Diagnostic Services"
                heading="Detect It Early: Explore Our"
                customClass="WellnessSectionWomen"
              />
              </div>
            </section>

      {/* <section>
        <div className={`strongcontainerlab ${isMobile ? "mobile" : ""}`}>
          <div className="rightstrongcontainerlab">
            <h2 className="heading1">
              Essential
              <span className="highlight1"> Lab Tests</span>
              <span className="line-break-heading"><br /></span> Packages
            </h2>
            <div className="test-slider-container-lab">
            <BloodTestSlider tests={tests} BloodTestsettings={BloodTestsettings} />
            </div>
          </div>
        </div>
      </section> */}

              {/* Packages + Request button */}
        <section>
          <div className="express-package">
            <div className="bolt-packages">
              <h2 className="heading1">
                <span className="highlight1"> Swasth 6.0</span>
                <span className="line-break-heading"><br /></span>
              </h2>
              <p>Focused on early detection, enhanced longevity and proactive control of your well-being</p>
              <div className="test-slider-container-lab">
                <BloodTestSlider tests={swasth} BloodTestsettings={BloodTestsettings} />
              </div>
            </div>
            <div className="service-section-button">
              <button className="buttonlanding" onClick={openPopup}>Request a Call Back</button>
            </div>
          </div>
        </section>
      
      <section>
        <div className={`aicontainer ${isMobile ? "mobile" : ""}`}>
          <div className="get-labcontainer">
            <h2 className="heading1">
            Get Lab Tests Done in just <br />
              <span className="highlight1"> 3 Simple Steps</span>
            </h2>
            
            <div className="get-lab-span">
              <span >Step 1</span>
              <hr className="get-lab-spanborder" />
              <span>Step 2</span>
              <hr className="get-lab-spanborder" />
              <span>Step 3</span>
            </div>

            <div className="get-lab-p">
                
              <div className="get-labpara1">
              <div className="get-lab-span-mob">
                <span >Step 1</span>
                </div>
                <div>
                  <img src="/images/new-website/radiology/book-test-new.webp" alt="" width={110}/> 
                </div>
                <div>
                  <h1 className="get-lab-heading">Book Your Test</h1>
                  <p>Schedule home sample collection or walk into the nearest BH clinic.</p>
                </div>
              </div>
              <div className="get-labpara1">
              <div className="get-lab-span-mob">
                <span >Step 2</span>
                </div>
                <div>
                  <img src="/images/new-website/radiology/sample-new.webp" alt=""  width={150}/> 
                </div>
                <div>
                  <h1 className="get-lab-heading">Give Your Sample</h1>
                  <p>Our trained representatives will assist your blood, urine, stool sample collection with utmost safety. </p>
                </div>
              </div>
              <div className="get-labpara1">
              <div className="get-lab-span-mob">
                <span >Step 3</span>
                </div>
                <div>
                  <img src="/images/new-website/radiology/report-new.webp" alt=""  width={110}/> 
                </div>
                <div>
                  <h1 className="get-lab-heading">Receive Your Reports</h1>
                  <p>Conveniently access digital reports or collect in person at the clinic.</p>
                </div>
              </div>
             
            </div>
          </div>
          
        </div>
      </section>
      <section className="nabl-iso">
        <div className="nabl-container">
          <h2 className="heading1">
            <span className="highlight1">NABL Accredited Lab </span>
            at JP Nagar, Bangalore
          </h2>
          <p>Because you deserve the best care with timely results </p>
        </div>
        <section style={styles.bannerSliderT1}>
          <SliderLab sliderSettings={sliderSettings} slides={slides} />
        </section>      
        </section>
        <section className="lab-test-callout">
          <div className="lab-test-callout-col">
            <h2>Book a<span> Lab Test</span> With Us</h2>
          </div>
          <div className="lab-test-callout-col">
            <div className="lab-test-callout-img">
              <img src="/images/new-website/radiology/medical-report.webp" alt="" />
            </div>
            <div className="lab-test-callout-details">
            {/* <Counter targetValue={98} duration={7000} /> */}
            <p style={{fontSize:"30px", fontWeight: "500", marginBottom: "0px"}}>98%</p>
              <p>On-time report delivery</p>
            </div>
          </div>
          <div className="lab-test-callout-col">
          <div className="lab-test-callout-img">
              <img src="/images/hormone-test.webp" alt="" />
            </div>
            <div className="lab-test-callout-details">
            {/* <Counter targetValue={97} duration={7000} /> */}
            <p style={{fontSize:"30px", fontWeight: "500", marginBottom: "0px"}}>97%</p>
              <p>Timely sample collection</p>
            </div>
          </div>
          <div className="lab-test-callout-col">
          <div className="lab-test-callout-img">
              <img src="/images/review.webp" alt="" />
            </div>
            <div className="lab-test-callout-details">
            {/* <Counter targetValue={99} duration={7000} /> */}
            <p style={{fontSize:"30px", fontWeight: "500", marginBottom: "0px"}}>99%</p>
              <p>Positive customer reviews</p>
            </div>
          </div>
        </section>
      <section className="why-choose-section-radio">
          <h2 className="heading1">Why Choose <span className="highlight1">Bridge Health</span> for Your <br/>Lab Tests?</h2>
                    
          <WhyLab
            whyData={whyData} 
            dynamicText="Radiology" 
            dynamicParagraph="We have some of the best specialists who bring years of experience and offer evidence – based treatment to ensure best care for you" 
          />

      </section>
    <section>
        <div>
        <FAQComponent faqs={faqs} />
        </div>
    </section>

    <section>
    <div className="testimonials-container">
      {/* Left Side */}
      <div className="left-section-testimonial">
        <h2>
        Trust Us Based on What Our <span className="highlight1">Patrons Say</span>
        </h2>
        <h3>Overall Ratings</h3>
        <div className="ratings">
          <img
            src="/images/new-website/women-care/google-logo-1.webp"
            alt="Google Logo"
          />
          <div>
            <p>
              4.9{" "}
              <span className="stars">
                ⭐⭐⭐⭐⭐
              </span>
            </p>
            <p>Customer Reviews</p>
          </div>
        </div>
        <a href="https://g.page/r/CagLkxSu4CfZEBM/review" target="_blank" rel="noopener noreferrer">
        <button className="buttonmaphome-review">Write a Review</button>
        </a>
      </div>

      {/* Right Side */}
      <div className="right-section-testimonial">
        <div className="testimonial-page">
      <TestimonialSlider testimonials={testimonials} />
    </div>
      </div>
    </div>
    </section>
    <Popup_Main isOpen={isOpen} onClose={() => setIsOpen(false)} >
        <ReachToUsForm submitted={() => setIsOpen(false)} />
        </Popup_Main>
        <Footer />
    </div>
  );
};

export default LabTestPage;
